import React from 'react';

import styles from './hotelPlannerCard.scss';

const HotelPlannerLogo: React.FC = () => (
  <a
    href="https://www.hotelplanner.com/Group"
    target="_blank"
    className={styles.poweredByLink}
    rel="noopener noreferrer"
  >
    <div className={styles.poweredByText}>powered by</div>
    <img
      src="https://media-api.xogrp.com/images/d984e6c5-68a9-4a01-ad8a-265e290c65ae"
      className={styles.hotelPlannerLogo}
      alt="Hotel Planner"
    />
  </a>
);

export default HotelPlannerLogo;
